<template lang="pug">
li.row
  FileIcon(:row="formatFile", :size="26")
  .meta
    el-tooltip(:content="file.fullName")
      FileName(:name="file.fullName || file.name")
    .size {{ file.size | fileSize }}
      template(v-if="isLoading && file.speed") &nbsp;{{ file.speed | fileSize }}/s
  el-tooltip(:disabled="!statusMessage", :content="statusMessage")
    .status
      template(v-if="isLoading")
        img.loading(src="./assets/loading.svg")
        label {{ file.progress }}%
      template(v-else)
        .icon.bg-success(v-if="isSuccess")
          i.el-icon-check
        .icon.bg-error(v-else-if="isError")
          i.el-icon-close
        .icon.bg-warning(v-else-if="isPending||isPause") !
        img.loading(v-else, src="./assets/loading.svg")
        label {{ file.statusText }}
  //- .progress
    el-progress(:show-text="false", :status="progressStatus", :percentage="file.progress")
  .control
    //- button(v-if="isError") 失败 - {{ file.message }}
    .btn(v-if="isLoading", @click="file.pause()")
      img(src="./assets/pause.svg")
    .btn(v-if="isError", @click="file.start()") #[i.el-icon-refresh-left]
    .btn(v-if="isPause", @click="file.start()")
      img(src="./assets/play.svg")
    .btn(@click="file.remove()") #[i.el-icon-close]
</template>
<script>
import { IUploader } from "./IUploader.js";
import { fileSize } from "@/CommonDP/components/FileList/file.js";
import FileName from "@/CommonDP/components/FileList/fileName.vue";
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
export default {
  filters: { fileSize },
  components: { FileName, FileIcon },
  props: { file: { default: null }},
  computed: {
    progressStatus() {
      switch (true) {
        case this.isSuccess:
          return "success";
        case this.isError:
          return "exception";
      }
      return void 0;
    },
    formatFile() {
      return { fileName: (this.file && this.file.name) || "" };
    },
    isLoading() {
      return IUploader.STATUS.UPLOADING === this.file.status;
    },
    isPause() {
      return IUploader.STATUS.PAUSE === this.file.status;
    },
    isError() {
      return IUploader.STATUS.ERROR === this.file.status;
    },
    isSuccess() {
      return IUploader.STATUS.SUCCESS === this.file.status;
    },
    isPending() {
      return IUploader.STATUS.PENDING === this.file.status;
    },
    statusMessage() {
      return this.file.message;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
.row {
  border-bottom: 1px solid #e9edf6;
  display: flex;
  flex-flow: row nowrap;
  height: 44px;
  align-items: center;
  .meta {
    flex: 1 1;
    cursor: default;
    overflow: hidden;
    margin: 0 8px;
  }
  .size {
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }
  .file-name {
    font-size: 14px;
    width: fit-content;
    max-width: 100%;
  }
  .progress {
    flex: 0 0 90px;
    margin: 0 8px;
  }
  .status {
    flex: 0 0 80px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    user-select: none;
    .loading {
      font-size: 14px;
      color: $--color-primary;
      margin-right: 4px;
      animation: loading 1s linear infinite;
    }
    .icon {
      $size: 16px;
      flex: 0 0 auto;
      width: $size;
      height: $size;
      line-height: $size;
      border-radius: 50%;
      margin-right: 4px;
      color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      > i {
        font-size: inherit;
      }
    }
    > label {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      flex: 1 1;
      font-size: 14px;
    }
  }
  .control {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    flex: 0 0 42px;
    $bg: #9dafc0;
    .btn {
      height: 16px;
      width: 16px;
      display: flex;
      flex-flow: row;
      justify-content: center;
      align-items: center;
      background-color: #9dafc0;
      color: #fff;
      font-size: 10px;
      padding: 0;
      margin-left: 8px;
      border-radius: 50%;
      cursor: pointer;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background-color: darken($bg, 10);
      }
    }
  }
}
.bg-success {
  background-color: $--color-success;
}
.bg-error {
  background-color: $--color-danger;
}
.bg-warning {
  background-color: $--color-warning;
}
@keyframes loading {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
